<template>
  <div class="device-doorlock">
    <div class="page-search-block">
      <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">门锁编码：</span>
        <el-input v-model="filters.search.deviceCode" class="w-120" placeholder="请输入" ></el-input>
      </div>
      <el-select class="select-as-label m-r-8 w-120" v-model="searchKey" placeholder="请选择">
        <el-option label="房源名称" value="roomName"></el-option>
        <el-option label="房源编码" value="roomCode"></el-option>
      </el-select>
      <el-input class="w-120 m-r-8" v-model="filters.search.searchVal" placeholder="请输入"></el-input>
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">在线状态：</span>
        <el-select v-model="filters.search.deviceStatus" class="w-120" clearable >
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="2"></el-option>
        </el-select>
      </div>
      <el-button class="submit-btn m-l-10" size="large" type="primary" @click="handleSearch">搜 索</el-button>
    </div>

    <div class="page-operate-block">
      <span class="tit">门锁列表</span>
      <div>
        <el-popover placement="bottom" trigger="click" popper-class="r-popover">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <br />
          <el-checkbox v-for="(column, index) in tableColumn" v-model="column.visible" :key="index" @change="_checkChange">{{ column.label }}</el-checkbox>
          <template #reference>
            <el-button class="operate-btn" name="dataSetting">数据项</el-button>
          </template>
        </el-popover>
        <el-button
          v-permission="'bind'"
          class="operate-btn"
          @click="showBindDialog('real')"
          :disabled="!(this.options.selection.length === 1 && !this.options.selection[0].roomId)"
          >门锁绑定</el-button
        >
        <el-button
          v-permission="'unbind'"
          class="operate-btn"
          @click="cancelBind"
          :disabled="!(this.options.selection.length === 1 && this.options.selection[0].roomId)"
          >门锁解绑</el-button
        >
        <el-button
          v-permission="'mockLock'"
          class="operate-btn"
          @click="showBindDialog('virtual')"
          >虚拟锁绑定</el-button
        >
      </div>
    </div>

    <div class="table-list-block">
      <r-table
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
        @sort-change="onSortChange"
      ></r-table>
    </div>

    <RModal
      customClass="m-h-unset"
      title="门锁绑定"
      top="15vh"
      :show="detailModal"
      :closeOnClick="false"
      width="500px"
      @change="detailModal = false"
      @close="detailModal = false"
    >
      <template #content>
        <bindView
          :storeId="curStore.id"
          :modalType="modalType"
          :detailModal="detailModal"
          :detailData="detailData"
          :deviceType="deviceType"
          @submitSuccess="submitSuccess"
          @close="closeModel"
        ></bindView>
      </template>
    </RModal>
  </div>
</template>

<script>
import RModal from "@/components/common/RModal"
import RTable from "@/components/common/RTable";
import tableMix from "@/components/common/tableListMixin.js";
import checkMix from "@/components/common/checkAll.js";
import bindView from "./bindView";

const EQUIPMENT_TYPE = 103; // 设备类型：门锁

export default {
  name: "equipDoorlock",
  mixins: [tableMix, checkMix],
  components: { RModal, RTable, bindView },
  data() {
    return {
      curStore: {},

      deviceType: EQUIPMENT_TYPE,
      modalType: 'real',

      // =================================================== 列表 table
      tableVarity: "equip-doorlock-table",
      tableColumn: [],
      tableData: [],
      detailModal: false,
      detailData: {},
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      searchKey: 'roomName',
      // 查询参数
      filters: {
        search: {
          deviceCode: "",
          deviceStatus: "",
          roomCode: "",
          electricity: "",
          searchVal: "",
          deviceCode: "",
        },
      },
      selOptions: {
        deviceStatus: [
          { name: 0, value: "离线" },
          { name: 1, value: "在线" },
        ],
      },
      sortParams: {},
    };
  },
  created() {
    let curStore = localStorage.getItem('curShop')
    if (!curStore || curStore === 'undefined' || curStore === 'null') {
      this.curStore = {}
    } else {
      this.curStore = JSON.parse(curStore)
    }
    this.$eventBus.on('change-shop', store => {
      this.curStore = store || {}
      this.getDataList(true)
    })
    
    this.initTableColumns();
    this.getQuery();
  },
  methods: {
    toLine(string){
      return string.replace(/([A-Z])/g, "_$1").toLowerCase();
    },
    onSortChange({order, prop}){
      const params = {};
      if(prop) params.orderFields = this.toLine(prop);
      if(order){
        params.sort = {
          ascending: 'asc',
          descending: 'desc',
        }[order];
      }
      this.sortParams = params;
      this.getQuery();
    },
    // 初始化自定义表头
    initTableColumns() {
      // 表头 visible：默认可见
      let columns = [
        { prop: "deviceCode", label: "门锁编码", visible: true, minWidth: 190, sortable: 'custom' },
        { prop: "btMac", label: "蓝牙Mac", visible: true, minWidth: 190 },
        { prop: "electricity", label: "电量", visible: true, minWidth: 120 },
        { prop: "deviceStatus", label: "在线状态", visible: true, minWidth: 130 },
        { prop: "latestHeartbeatTime", label: "最近一次心跳时间", visible: true, minWidth: 180, sortable: 'custom' },
        { prop: "deviceImsi", label: "IMSI", visible: false, minWidth: 160 },
        { prop: "deviceImei", label: "IMEI", visible: false, minWidth: 160 },
        { prop: "deviceIccid", label: "ICCID", visible: false, minWidth: 180 },
        { prop: "firstUnlockTime", label: "首次开锁时间", visible: false, minWidth: 160 },
        { prop: "realManagerName", label: "经营者名称", visible: true, minWidth: 130 },
        { prop: "roomName", label: "房源名称", visible: true, minWidth: 250 },
        { prop: "roomCode", label: "房源编码", visible: false, minWidth: 250 },
        { prop: "roomAddress", label: "房源地址", visible: true, minWidth: 250 },
        { prop: "fjh", label: "房间号", visible: false, minWidth: 250 },
        { prop: "deviceModel", label: "门锁型号", visible: false, minWidth: 190 },
        { prop: "companyName", label: "门锁厂商", visible: false, minWidth: 200 },
        { prop: "deviceVersion", label: "版本信息", visible: true, minWidth: 250 },
        { prop: "lastUnlockTime", label: "近一次开锁时间", visible: false, minWidth: 160 },
        { prop: "installPerson", label: "门锁安装人", visible: false, minWidth: 160 },
        { prop: "installTime", label: "门锁安装时间", visible: true, minWidth: 160 },
      ];

      columns.forEach((item) => {
        if (item.prop === "deviceCode") {
          // render 函数列单元格渲染规则
          item.render = (row, index, column) => {
            return (
              <a onClick={this.handleShowDetail.bind(this, row)}>
                {row[item.prop]}
              </a>
            );
          };
        }
        if (item.prop === "companyName") {
          item.render = (row, index, column) => {
            return <div>瑞为技术</div>;
          };
        }
        if (item.prop === "electricity") {
          item.render = (row, index, column) => {
            const value = row[item.prop];
            return <span>{typeof value == 'number' ? value : '--'}</span>
          };
        }
        if (item.prop === "deviceStatus") {
          item.render = (row, index, column) => {
            if (row.deviceStatus == 1) {
              return <span>在线</span>;
            } else {
              return <span>离线</span>;
            }
          };
        }
      });

      this.tableColumn = columns;
    },
    // 显示日志详情
    handleShowDetail(row) {
      this.$emit("change-view", row);
    },
    // 获取查询参数
    getQueryParams() {
      let searches = {};
      for (let name in this.filters.search) {
        if (this.filters.search[name] === "") {
          continue;
        }
        let searchParam = this.filters.search[name];
        searches[name] =
          typeof searchParam === "string" ? searchParam.trim() : searchParam;
      }
      if (searches.searchVal) {
        searches[this.searchKey] = searches.searchVal
      }
      delete searches.searchVal

      return {
        ...searches,
        storeId: this.curStore.id || '',
        deviceType: this.deviceType,
        pageNumber: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
        ...this.sortParams,
      };
    },
    // 查询列表数据
    getQuery() {
      this.options.loading = true;
      let params = this.getQueryParams();

      let url = "DEVICE.GET_LIST";
      this.fetchData({
        url,
        method: "get",
        params,
      })
        .then((res) => {
          this.options.loading = false;

          if (!res || !res.data) {
            this.tableData = [];
            this.pagination.total = 0;
          } else {
            this.tableData = res.data || [];
            this.pagination.total = res.rowCount;
          }
        })
        .catch((err) => {
          console.log(err, "=== 门锁列表获取失败");
        })
        .finally(() => {
          this.options.loading = false;
        });
    },
    showBindDialog(type) {
      this.modalType = type
      this.$nextTick(() => {
        this.detailModal = true;
        if (this.options.selection.length && type === 'real') {
          this.detailData = { ...this.options.selection[0] };
        } else {
          this.detailData = {};
        }
      });
    },
    // 设备解绑
    cancelBind() {
      let tipStr = "该操作是不可恢复的，确定解绑？";
      this.$confirm(tipStr, { type: "warning" })
        .then(() => {
          this.doCancelBind();
        })
        .catch(() => false);
    },
    // 设备解绑
    doCancelBind() {
      let url = "DEVICE.GET_UNBIND";
      let delDevice = this.options.selection[0]
      let params = {
        roomId: delDevice.roomId,
        deviceCode: delDevice.deviceCode,
        deviceType: this.deviceType,
      };
      this.fetchData({ url: url, method: "get", params, flag: true }).then((res) => {
        if (res.code == 200) {
          this.$message.success('解绑成功！')
          this.submitSuccess()
          return
        }
        this.$message.error(res.msg || '解绑失败！')
      }).catch((err) => {
        this.$message.error(err || "解绑失败！")
      }).finally(() => {
        this.saveLoading = false;
      });
    },
    // 操作成功，刷新列表
    submitSuccess() {
      this.detailModal = false;
      this.getDataList();
    },
    // 关闭弹框
    closeModel() {
      this.detailModal = false;
    },
  },
};
</script>

<style lang="less">
.m-h-unset .el-dialog__body {
  min-height: unset !important;
}
</style>